import React from 'react'
import PropTypes from 'prop-types'

const MyCoursesHeader = props => {
  return (
    <React.Fragment>
      <li className="dropdown-header ml-0 pl-2">
        <span>{props.name}</span>
      </li>
    </React.Fragment>
  )
}

MyCoursesHeader.propTypes = {
  name: PropTypes.string,
}

export default MyCoursesHeader
